"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var radium_1 = require("radium");
var context_1 = require("../../context");
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a = this.props, style = _a.style, primary = _a.primary, secondary = _a.secondary, text = _a.text, className = _a.className, rest = __rest(_a, ["style", "primary", "secondary", "text", "className"]);
        return (React.createElement(context_1.THEME_CONTEXT.Consumer, null, function (theme) {
            var compiledStyles = styles(theme, style);
            return (React.createElement("button", __assign({}, rest, { className: className, style: __assign({ boxSizing: 'border-box' }, compiledStyles.main, (primary ? compiledStyles.primary : null), (!primary && secondary ? compiledStyles.secondary : null)) }), text));
        }));
    };
    Button = __decorate([
        radium_1.default
    ], Button);
    return Button;
}(React.Component));
exports.Button = Button;
var styles = function (theme, style) { return ({
    main: __assign({ background: theme.button.normal.normalBackground, borderLeft: theme.button.normal.borderLeft, borderRight: theme.button.normal.borderRight, borderTop: theme.button.normal.borderTop, borderBottom: theme.button.normal.borderBottom, borderRadius: theme.button.borderRadius, color: theme.button.normal.textColor, fontSize: theme.common.fontSize, letterSpacing: '.5px', outline: 'none', padding: theme.button.padding, 
        //
        ':focus': {
            borderLeft: theme.button.borderWidth + "px solid " + theme.button.outlineBorderColor,
            borderRight: theme.button.borderWidth + "px solid " + theme.button.outlineBorderColor,
            borderTop: theme.button.borderWidth + "px solid " + theme.button.outlineBorderColor,
            borderBottom: theme.button.borderWidth + "px solid " + theme.button.outlineBorderColor,
        }, 
        //
        ':active': {
            background: theme.button.normal.pressedBackground,
            borderLeft: theme.button.normal.borderRight,
            borderRight: theme.button.normal.borderLeft,
            borderTop: theme.button.normal.borderBottom,
            borderBottom: theme.button.normal.borderTop,
            boxShadow: 'none',
        }, 
        //
        ':disabled': {
            color: theme.button.disabledColor,
            borderLeft: theme.button.borderWidth + "px solid " + theme.button.disabledColor,
            borderRight: theme.button.borderWidth + "px solid " + theme.button.disabledColor,
            borderTop: theme.button.borderWidth + "px solid " + theme.button.disabledColor,
            borderBottom: theme.button.borderWidth + "px solid " + theme.button.disabledColor,
            background: theme.button.disabledBackground,
        } }, style),
    primary: {
        background: theme.button.primary.normalBackground,
        borderLeft: theme.button.primary.borderLeft,
        borderRight: theme.button.primary.borderRight,
        borderTop: theme.button.primary.borderTop,
        borderBottom: theme.button.primary.borderBottom,
        color: theme.button.primary.textColor,
        //
        ':active': {
            background: theme.button.primary.pressedBackground,
            borderLeft: theme.button.primary.borderRight,
            borderRight: theme.button.primary.borderLeft,
            borderTop: theme.button.primary.borderBottom,
            borderBottom: theme.button.primary.borderTop,
            boxShadow: 'none',
        },
    },
    secondary: {
        background: theme.button.secondary.normalBackground,
        borderLeft: theme.button.secondary.borderLeft,
        borderRight: theme.button.secondary.borderRight,
        borderTop: theme.button.secondary.borderTop,
        borderBottom: theme.button.secondary.borderBottom,
        color: theme.button.secondary.textColor,
        //
        ':active': {
            background: theme.button.secondary.pressedBackground,
            borderLeft: theme.button.secondary.borderRight,
            borderRight: theme.button.secondary.borderLeft,
            borderTop: theme.button.secondary.borderBottom,
            borderBottom: theme.button.secondary.borderTop,
            boxShadow: 'none',
        },
    },
}); };
